export function ContactPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-14">
      <h1 className="text-3xl font-bold text-ink-900">Contact us</h1>
      <p className="mt-3 text-ink-700">
        For institutional rollouts, curriculum packs for another country's syllabus, or a
        demonstration for your ministry or school network.
      </p>

      <div className="mt-8 grid gap-4 sm:grid-cols-2">
        <div className="card">
          <h2 className="text-base font-semibold text-ink-900">VISINA Consult Limited</h2>
          <p className="mt-1 text-sm text-ink-600">
            STEM Africa Learning Hub is a subsidiary of VISINA Consult Limited.
          </p>
        </div>
        <div className="card">
          <h2 className="text-base font-semibold text-ink-900">Institutional enquiries</h2>
          <p className="mt-1 text-sm text-ink-600">
            Tell us the number of schools, the curriculum, and whether you need data residency in
            your own country. Those three answers shape the whole proposal.
          </p>
        </div>
      </div>

      {/*
        A `mailto:` rather than a form, deliberately.
        A contact form needs an inbox, a spam defence and somebody to answer it,
        and a form that posts into a void is worse than no form — the sender
        believes they have been heard. When there is a real desk behind it, this
        becomes a form.
      */}
      <div className="card mt-6">
        <h2 className="text-base font-semibold text-ink-900">Write to us</h2>
        <p className="mt-1 text-sm text-ink-600">
          Email is the fastest route while we are onboarding our first partners.
        </p>
        <a className="btn-primary mt-4" href="mailto:info@visinaconsult.co.ke">
          info@visinaconsult.co.ke
        </a>
      </div>
    </div>
  );
}
